import Application from "../../Application";
import ChangePasswordPresenter, {
  IChangePasswordPresenter,
  TPasswordChangePresentationModel
} from "../../presenter/authentication/ChangePasswordPresenter";
import { ILanguageService } from "../../service/language/LanguageService";
import ShowSuccessMessageInteractor from "../notifications/ShowSuccessMessageInteractor";
import SettingsPresenter, {
  ISettingsPresenter
} from "../../presenter/settings/SettingsPresenter";
import { ICredentialsService } from "../../service/authentication/CredentialsService";
import { UserPreferences, AppConstants } from "../../common/Constants";

export default class ShowSettingsInteractor {
  private application: Application;
  private output?: IChangePasswordPresenter;
  private settings?: ISettingsPresenter;
  private languageService: ILanguageService;
  private credentialsService: ICredentialsService;

  constructor(application, languageService, credentialsService) {
    this.application = application;
    this.languageService = languageService;
    this.credentialsService = credentialsService;
  }

  async getLanguages() {
    try {
      return this.languageService.getLanguages();
    } catch (error) {
      this.application.container
        .resolve<ShowSuccessMessageInteractor>("showSuccessMessage")
        .execute((error as any).message);
    }
  }

  async getCurrentLanguageCode() {
    const currentLanguage = await this.credentialsService.getLanguage();
    return Number(currentLanguage);
  }

  async getInitalData() {
    let languages = await this.getLanguages();
    let currentLanguageCode = await this.getCurrentLanguageCode();
    currentLanguageCode = currentLanguageCode
      ? currentLanguageCode
      : UserPreferences.DEFAULT_LANGUAGE;
    return { languages, currentLanguageCode };
  }

  execute() {
    this.output = ChangePasswordPresenter({
      application: this.application,
      initialState: {
        passwordPresentationModel: {} as TPasswordChangePresentationModel,
        validationPasswordErrors: {},
        isChangeButtonDisabled: false
      }
    });
    this.settings = SettingsPresenter({
      application: this.application,
      initialState: {
        languages: [],
        currentLanguageCode: UserPreferences.DEFAULT_LANGUAGE,
        isPortalActive: true
      }
    });

    const isPortalActive =
      this.application.applicationName === AppConstants.PORTAL;

    this.getInitalData().then(
      (result) =>
        this.settings &&
        this.settings.setInitialData(
          result.languages ? result.languages : [],
          result.currentLanguageCode,
          isPortalActive
        )
    );

    return { ...this.output, ...this.settings };
  }
}
